import { ColumnCta } from '@ahc-digital/component-library';
import { CreateMultiColumnCTAModel } from './C05MultilcolumnCTA.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { C05MulticolumnCTAProps } from './C05MulticolumnCTA.types';

const Default = (props?: C05MulticolumnCTAProps) => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <ColumnCta
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateMultiColumnCTAModel(props)}
    />
  );
};

export default checkDatasourceForRendering<C05MulticolumnCTAProps>(Default);
